import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'

const styles = (theme: Theme) => {
    return { success: css`
            ${common.flexJustityAlignCenter};
            height: 111px;
            font-size: ${theme.typography.h3.fontSize}px;
            line-height: ${theme.typography.h3.lineHeight};
            color: ${theme.palette.secondary[600]};
        ` }
}

export default styles
